import React from "react";
import callToAction from "../images/callToAction.svg";
import "../styles/Call.scss";

const Call = () => {
  const phoneNumber = "5213345851702";
  const message = "Hola, me gustaría obtener más información de sus servicios.";

  const handleClick = () => {
    window.open(
      `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`,
      "_blank"
    );
  };

  return (
    <div className="callFloating" onClick={handleClick}>
      <img src={callToAction} alt="WhatsApp contacto Pixbae Banquetes" />
    </div>
  );
};

export default Call;
